import { Select } from "antd";
import React from "react";
import { useSelector } from "react-redux";

interface Props {
  className?: string;
  value?: string[];
  onChange?: (value: string[]) => void;
}

const MultiShiftSelect = ({ value, onChange, className = "" }: Props) => {
  const {
    shifts_list_data = [],
  }: {
    shifts_list_data: Array<Shift>;
    // @ts-ignore
  } = useSelector((state) => state.shift);

  return (
    <Select
      className={`${className}`}
      mode="multiple"
      value={value}
      onChange={onChange}
      placeholder="Select Shifts"
    >
      {shifts_list_data.map((shift) => (
        <Select.Option key={shift.id} value={shift.id}>
          {shift.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default MultiShiftSelect;
